import React from "react";
import { Heading } from "@tennr/frontend/components/Heading";
import { HubspotForm } from "@tennr/frontend/components/BookDemoForm";
import "./CompetitorComparisonHeroSection.css";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";

export const CompetitorComparisonHeroSection: React.FC = ({ competitor }) => {
  var competitorName = "";
  var audience = "";

  // will just replace all of this with sanity data
  switch (competitor.toString()) {
    case "abbadox":
      competitorName = "Abbadox";
      audience = "imaging service providers";
      break;
    case "alayacare":
      competitorName = "AlayaCare";
      audience = "infusion centers";
      break;
    case "alpha-nodus":
      competitorName = "Alpha Nodus";
      audience = "imaging service providers";
      break;
    case "calvient":
      competitorName = "Calvient";
      audience = "imaging service providers";
      break;
    case "celeritas-ai":
      competitorName = "Celeritas AI";
      audience = "DMEs & HMEs";
      break;
    case "change-healthcare":
      competitorName = "Change Healthcare";
      audience = "imaging service providers";
      break;
    case "darby":
      competitorName = "Darby";
      audience = "DMEs & HMEs";
      break;
    case "dmescripts":
      competitorName = "DMEScripts";
      audience = "DMEs & HMEs";
      break;
    case "forcura":
      competitorName = "Forcura";
      audience = "providers and suppliers";
      break;
    case "lamar-health":
      competitorName = "Lamar Health";
      audience = "infusion centers & specialty pharmacies";
      break;
    case "latent-health":
      competitorName = "Latent Health";
      audience = "infusion centers & specialty pharmacies";
      break;
    case "mandolin":
      competitorName = "Mandolin";
      audience = "infusion centers";
      break;
    case "medsender":
      competitorName = "Medsender";
      audience = "providers and suppliers";
      break;
    case "notable-systems":
      competitorName = "Notable Systems";
      audience = "DMEs & HMEs";
      break;
    case "parachute-health":
      competitorName = "Parachute Health";
      audience = "DMEs & HMEs";
      break;
    case "samacare":
      competitorName = "SamaCare";
      audience = "infusion centers";
      break;
    case "silna":
      competitorName = "Silna";
      audience = "DMEs & HMEs";
      break;
    case "synthpop":
      competitorName = "Synthpop";
      audience = "DMEs & HMEs";
      break;
    default:
      competitorName = "the alternatives";
      audience = "providers";
  }

  const heroTitle = "Tennr vs. " + competitorName;
  const heroSubtitle = "See why " + audience + " prefer Tennr over " + competitorName;
  return (
    <>
      <MetadataTags
        title={heroTitle}
        description={heroSubtitle}
        imageUrl="https://tennr.com/share_cards/sharecard.png"
      />
      <section className="competitor-comparison-hero-section">
        <div className="competitor-comparison-hero-section-content">
          <Heading
            title={heroTitle}
            heading={heroSubtitle}
            className="book-hero-title"
            body="Tennr is powered by RaeLM™, the only vision-language model trained to interpret unstructured medical records against complex payor criteria.

                    Tennr streamlines the pre-visit process so you can run a high-performance pipeline and get paid faster."
            variant="hero"
            width={550}
          />
          <HubspotForm {...{ portalId: "23158831", formId: "ad73a2c1-22c3-4737-baa5-1944023021d0",region : "na1"}}/>
        </div>
      </section>
    </>
  );
};
